import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

// Resolve an image src: uploaded media (/api/media/..) needs the backend host.
export const img = (src) => {
  if (!src) return undefined;
  if (src.startsWith("/api/")) return BACKEND_URL + src;
  return src;
};

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("mb_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const fetchSettings = () => client.get("/settings").then((r) => r.data);
export const fetchProducts = () => client.get("/products").then((r) => r.data);
export const fetchProduct = (id) => client.get(`/products/${id}`).then((r) => r.data);
export const createOrder = (payload) => client.post("/orders", payload).then((r) => r.data);
export const trackOrder = (orderId) => client.get(`/orders/track/${orderId}`).then((r) => r.data);
export const validatePromo = (code, subtotal) => client.post("/promo/validate", { code, subtotal }).then((r) => r.data);
export const sendContact = (data) => client.post("/contact", data).then((r) => r.data);

// Admin auth
export const adminLogin = (username, password) =>
  client.post("/admin/login", { username, password }).then((r) => r.data);
export const adminMe = () => client.get("/admin/me").then((r) => r.data);
export const changePassword = (current, newPass) =>
  client.put("/admin/password", { current, new: newPass }).then((r) => r.data);

// Admin uploads
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client
    .post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// Admin data
export const saveSettings = (settings) => client.put("/admin/settings", settings).then((r) => r.data);
export const patchSettings = (partial) => saveSettings(partial);
export const fetchAdminSettings = () => client.get("/admin/settings").then((r) => r.data);
export const fetchStats = () => client.get("/admin/stats").then((r) => r.data);
export const fetchEmailTemplates = () => client.get("/admin/email-templates").then((r) => r.data);
export const emailOrder = (id, template) => client.post(`/admin/orders/${id}/email`, { template }).then((r) => r.data);
export const fetchAdminProducts = () => client.get("/admin/products").then((r) => r.data);
export const duplicateProduct = (id) => client.post(`/admin/products/${id}/duplicate`).then((r) => r.data);
export const bulkDeleteOrders = (ids) => client.post("/admin/orders/bulk-delete", { ids }).then((r) => r.data);
export const eraseOrderCustomer = (id) => client.post(`/admin/orders/${id}/erase-customer`).then((r) => r.data);
export const postCustomerUpdate = (id, message, notify) => client.post(`/admin/orders/${id}/updates`, { message, notify }).then((r) => r.data);
export const deleteCustomerUpdate = (id, idx) => client.delete(`/admin/orders/${id}/updates/${idx}`).then((r) => r.data);
export const fetchCustomers = () => client.get("/admin/customers").then((r) => r.data);
export const eraseCustomer = (email) => client.post("/admin/customers/erase", { email }).then((r) => r.data);
export const exportOrdersCsv = async () => {
  const r = await client.get("/admin/orders/export", { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = `orders-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
  URL.revokeObjectURL(url);
};
export const deleteOrder = (id) => client.delete(`/admin/orders/${id}`).then((r) => r.data);
export const fetchMessages = () => client.get("/admin/messages").then((r) => r.data);
export const markMessageRead = (id) => client.put(`/admin/messages/${id}/read`).then((r) => r.data);
export const deleteMessage = (id) => client.delete(`/admin/messages/${id}`).then((r) => r.data);
export const createProduct = (p) => client.post("/admin/products", p).then((r) => r.data);
export const updateProduct = (id, p) => client.put(`/admin/products/${id}`, p).then((r) => r.data);
export const deleteProduct = (id) => client.delete(`/admin/products/${id}`).then((r) => r.data);
export const fetchOrders = () => client.get("/admin/orders").then((r) => r.data);
export const updateOrder = (id, data) => client.put(`/admin/orders/${id}`, data).then((r) => r.data);

export default client;

export const contactLink = (url) => (url ? { href: url, target: "_blank", rel: "noreferrer" } : { href: "/contact" });
